/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsCustomSacCalculatorViewProps } from './hosports-custom-sac-calculator';

export default (props: IHosportsCustomSacCalculatorViewProps) => {
    return (
        <h2>{'Custom Sac Calculator'}</h2>
    );
};
